import styled from 'styled-components';

export default styled.div`
  border: 1px solid rgba(72, 94, 144, 0.16);
  border-top: none;
  width: 450px;
  padding: 25px;
  position: absolute;
  top: 80px;
  height: calc(100vh - 80px);
  overflow-y: scroll;
  right: 0px;
  background: #fff;
  z-index: 1000;
  box-shadow: 2px 0px 10px #666;
`;
